import { Entity, Asset, EventHandler } from 'playcanvas';


const slots = [ 'head', 'hair', 'top', 'top:secondary', 'bottom', "bottom:secondary", 'shoes', 'legs', 'torso' ];


class AvatarLoader extends EventHandler {
    app;

    rootAsset = null;
    assets = { };
    entities = { };

    urls = { };
    loading = new Map();
    next = new Map();
    index = new Map();

    legs = false;
    torso = false;

    gender = 'female';
    skin = 1;

    entity = null;
    slotEntities = { };
    animTrack = null;

    constructor(app, data) {
        super();

        window.avatarLoader = this;
        this.app = app;
        this.data = data;

        this.indexData();
    }

    createRootEntity(asset) {
        if (this.entity) return;

        this.rootAsset = asset;

        this.entity = asset.resource.instantiateRenderEntity();

        this.entity.addComponent('anim', {
            activate: true,
            speed: 1
        });
        this.entity.anim.rootBone = this.entity;

        // compensate for weird animation
        this.entity.setLocalPosition(0, 0.08, 0);

        this.app.root.addChild(this.entity);

        this.entity.forEach((ent) => {
            ent.removeComponent('render');
        });

        for(let i = 0; i < slots.length; i++) {
            const entity = new Entity(slots[i]);
            this.slotEntities[slots[i]] = entity;
            entity.addComponent('render', {
                type: 'asset',
                rootBone: this.entity
            });
            this.entity.addChild(entity);
        }

        this.loadAnimation();
    }

    loadAnimation() {
        const fileName = 'idle.glb';
        const url = `/anim/${fileName}`;

        this.assetAnimIdle = new Asset(fileName, 'container', { url, filename: fileName }, null, {
            // filter out translation from animation,
            // apart from the root
            animation: {
                preprocess: (data) => {
                    data.channels = data.channels.filter((item) => {
                        return item.target.node <= 2 || item.target.path === 'rotation';
                    });
                }
            }
        });

        this.assetAnimIdle.ready(() => {
            this.animTrack = this.assetAnimIdle.resource.animations[0].resource;
            this.entity.anim.assignAnimation('idle', this.animTrack);
        });

        this.app.assets.add(this.assetAnimIdle);
        this.app.assets.load(this.assetAnimIdle);
    }

    setGender(gender) {
        this.gender = gender;
        this.loadTorso();
        if (this.legs) this.loadLegs();
    }

    setSkin(skin) {
        this.skin = skin;
        this.loadTorso();
        if (this.legs) this.loadLegs();
    }

    loadTorso() {
        const item = this.torso ? 'torsoArms' : 'arms';
        const url = `${this.data.genders[this.gender].body[item]}_${(this.skin + '').padStart(2, '0')}.glb`;
        this.load('torso', url);
    }

    loadLegs() {
        const legs = `${this.data.genders[this.gender].body.legs}_${(this.skin + '').padStart(2, '0')}.glb`;
        this.load('legs', legs);
    }

    indexData() {
        const slots = [ 'top', 'bottom' ];

        for(let gender in this.data.genders) {
            for(let s = 0; s < slots.length; s++) {
                const slot = slots[s];
                const section = this.data.genders[gender][slot];

                for(let i = 0; i < section.list.length; i++) {
                    const item = section.list[i];
                    const url = `${item.file}.glb`;
                    this.index.set(url, item);
                }
            }
        }
    }

    checkBodySlot(slot, url) {
        if (slot === 'top') {
            if (this.index.get(url)?.torso) {
                this.torso = true;
                this.loadTorso();
            } else {
                this.torso = false;
            }
        } else if (slot === 'bottom') {
            if (this.index.get(url)?.legs) {
                this.legs = true;
                this.loadLegs();
            } else {
                this.legs = false;
            }
        }
    }

    uncheckBodySlot(slot, url) {
        if (slot === 'top') {
            if (!this.index.get(url)?.torso) {
                this.torso = false;
                this.loadTorso();
            }
        } else if (slot === 'bottom') {
            if (!this.index.get(url)?.legs) {
                this.legs = false;
                this.unload('legs');
            }
        }
    }

    checkLoading() {
        const loading = this.loading.size !== 0;
        document.body.classList.toggle('loading', loading);
    }

    load(slot, url) {
        // still loading something for the slot
        if (this.loading.has(slot)) {
            const urlNext = this.next.get(slot);
            if (urlNext) this.fire(`loaded:${slot}:${urlNext}`);

            if (this.loading.get(url) === url) {
                this.next.delete(slot);
            } else {
                this.next.set(slot, url);
                this.urls[slot] = url;
                this.fire(`loading:${slot}:${url}`);
            }
            return;
        }

        if (url === null) {
            if (this.slotEntities[slot]) {
                this.slotEntities[slot].render.asset = null;
                this.slotEntities[slot].render.materialAssets = [];
            }

            delete this.urls[slot];

            this.checkLoading();
            return;
        }

        this.fire(`loading:${slot}:${url}`);

        const name = url.split('/').pop();
        const asset = new Asset(name, 'container', { url, filename: name });
        this.loading.set(slot, url);
        this.app.assets.add(asset);

        this.urls[slot] = url;
        
        this.checkBodySlot(slot, url);

        asset.ready(() => {
            this.loading.delete(slot);
            this.fire(`loaded:${slot}:${url}`);

            this.createRootEntity(asset);

            // if (this.assets[slot] && this.rootAsset !== this.assets[slot]) {
            //     this.assets[slot].unload();
            //     this.app.assets.remove(this.assets[slot]);
            // }
    
            this.assets[slot] = asset;

            const container = this.assets[slot].resource;

            this.slotEntities[slot].render.asset = container.renders[0];
            this.slotEntities[slot].render.materialAssets = container.materials;

            this.uncheckBodySlot(slot, url);

            // load next in queue
            if (this.next.has(slot)) {
                const urlNext = this.next.get(slot);
                this.next.delete(slot);
                if (urlNext) {
                    this.load(slot, urlNext);
                } else {
                    this.unload(slot);
                }
            }

            this.checkLoading();
        });

        this.app.assets.load(asset);

        this.checkLoading();
    }

    unload(slot) {
        if (this.loading.has(slot)) {
            this.next.set(slot, null);
            return;
        }

        this.slotEntities[slot].render.asset = null;
        this.slotEntities[slot].render.materialAssets = [];

        delete this.urls[slot];

        this.checkLoading();
    }
}

export default AvatarLoader;